export default __webpack_public_path__ + "static/media/bra-arte-3.b1af47ef.webp";